import { CORE_SIZE } from '../../constants/index.es.js';

const BUTTON_CONFIG = {
  height: {
    xs: CORE_SIZE.s24,
    s: CORE_SIZE.s32,
    m: CORE_SIZE.s40,
    l: CORE_SIZE.s48
  },
  textColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textPrimary",
    link: "link500",
    "white-ghost": "primary500"
  },
  iconColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textSecondary",
    link: "link500",
    "white-ghost": "primary500"
  },
  disabled: {
    textColor: {
      primary: "placeholder",
      secondary: "placeholder",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    },
    iconColor: {
      primary: "border",
      secondary: "border",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    }
  }
};

export { BUTTON_CONFIG };
